export default __webpack_public_path__ + "static/media/Steel City.4fc919e7.jpg";